import React from "react";
import { MultiSelect as MSelect } from "@progress/kendo-react-dropdowns";
import Notification from "./Notification.tsx";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn, GridCell } from "@progress/kendo-react-grid";
import $ from "jquery";

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.core = this.props.args;
    this.state = {
      userList: [],
      selectedUsers: [],
      filterValue: false,
    };
    this.helper = this.core.make("oxzion/restClient");
    this.loader = this.core.make("oxzion/splash");
    this.notif = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.getMainList = this.getMainList.bind(this);
  }
  async ExcludeUsers(api, term, size) {
    if (term) {
      var query = {
        filter: {
          logic: "and",
          filters: [{ field: "name", operator: "contains", value: term }],
        },
        skip: 0,
        take: size,
      };
    } else {
      var query = {
        skip: 0,
        take: size,
      };
    }
    let filter={filter: "[" + JSON.stringify(query) + "]" };
    this.props.config.subList=="account"?filter["excludeAccount"]=this.props.config.dataItem.uuid:null;
    let response = await this.helper.request(
      "v1",
      "/" + api,
      filter,
      "post"
    );
    return response;
  }
  async ExistingUsers(api, selectedEntity) {
    let response = await this.helper.request(
      "v1",
      "/" + api + "/" + selectedEntity + "/users?"+`filter=[{"take":1000, "skip":0}]`,
      {},
      "get"
    );
    return response;
  }

  async componentDidMount() {
    this.loader.show();

    if (typeof this.props.config.subList == "object") {
      this.setState({
        selectedUsers: this.props.config.subList,
      });
    } else {
      const response = await this.ExistingUsers(
        this.props.config.subList,
        this.props.config.dataItem.uuid
      );
      var tempUsers = [];
      for (var i = 0; i <= response.data.length - 1; i++) {
        var userName = response.data[i].name;
        var userid = response.data[i].uuid;
        var is_manager =
          response.data[i].is_manager || response.data[i].is_admin;
        tempUsers.push({
          uuid: userid,
          name: userName,
          is_manager: is_manager,
        });
      }
      this.setState({
        selectedUsers: tempUsers,
      });
    }
    this.loader.destroy();
  }

  getMainList = (query, size) => {
    var excludeUsersList = [];
    this.state.selectedUsers.map((dataItem) => {
      excludeUsersList.push(dataItem.uuid);
    });
    this.ExcludeUsers(
      this.props.config.mainList,
      query,
      size
    ).then((response) => {
      var tempUsers = [];
      for (var i = 0; i <= response.data.length - 1; i++) {
        var userName = response.data[i].name;
        var userid = response.data[i].uuid;
        tempUsers.push({ uuid: userid, name: userName });
      }
      this.setState({
        userList: tempUsers,
      });
    });
  };

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  filterChange = (e) => {
    this.setState({
      filterValue: e.filter.value.length > 0,
    });
    if (e.filter.value.length > 0) {
      this.getMainList(e.filter.value, 20);
    } else {
      this.setState({
        userList: [],
      });
    }
  };

  handleChange(e) {
    if (this.state.filterValue) {
      this.setState({
        selectedUsers: e.target.value,
      });
    }
  }

  listNoDataRender = (element) => {
    const noData = (
      <h4 style={{ fontSize: "1em" }}>
        <span style={{ fontSize: "2.5em" }}>
          <i className="fa fa-search"></i>
        </span>
        <br />
        <br />
        Please type a name to search.
      </h4>
    );

    return React.cloneElement(element, { ...element.props }, noData);
  };

  tagRender = () => {
    $(document).ready(function (item) {
      $(".k-searchbar")
        .children()
        .attr({
          placeholder: "Search - Type The Name",
        })
        .css("min-width", "387px");
    });
  };

  deleteRecord = (item) => {
    // Check if this is a Teams or Projects module that should use DELETE API
    const shouldUseDeleteAPI = this.shouldUseDeleteAPI();
    if (shouldUseDeleteAPI) {
      // Show confirmation dialog before deleting
      const alertAdapter = this.core.make("oxzion/alert");
      const moduleType = this.getModuleType();
      
      alertAdapter?.show({
        title: "Remove User",
        text: `Are you sure you want to remove ${item.name} from this ${moduleType}?`,
        confirmButtonText: "Yes, remove",
        cancelButtonText: "Cancel",
        icon: "warning",
      }).then((isConfirmed) => {
        if (isConfirmed) {
          // User confirmed, proceed with API call
          this.removeUserFromEntity(item);
        }
      });
    } else {
      // Use original array removal behavior for other modules
      this.removeUserFromArray(item);
    }
  };

  shouldUseDeleteAPI = () => {
    // Check if this is Teams or Projects module based on subList path
    const subListPath = this.props.config.subList;
    return subListPath && (
      subListPath.includes('/team') || 
      subListPath.includes('/project')
    );
  };

  getModuleType = () => {
    const subListPath = this.props.config.subList;
    if (subListPath && subListPath.includes('/team')) {
      return 'team';
    } else if (subListPath && subListPath.includes('/project')) {
      return 'project';
    }
    return 'entity';
  };

  removeUserFromArray = (item) => {
    const selectedUsers = this.state.selectedUsers.slice();
    const index = selectedUsers.findIndex((p) => p.uuid === item.uuid);
    if (index !== -1) {
      selectedUsers.splice(index, 1);
      this.setState({
        selectedUsers: selectedUsers,
      });
    }
  };

  removeUserFromEntity = async (item) => {
    try {
      this.loader.show();
      
      // Extract account ID and entity ID from the config
      const subListPath = this.props.config.subList;
      const accountId = subListPath.split('/')[1]; // Extract from "account/{accountId}/team" or "account/{accountId}/project"
      const entityId = this.props.config.dataItem.uuid;
      const moduleType = this.getModuleType();
      
      // Build the appropriate API endpoint based on module type
      let apiEndpoint;
      if (moduleType === 'team') {
        apiEndpoint = `/account/${accountId}/team/${entityId}/remove-user`;
      } else if (moduleType === 'project') {
        apiEndpoint = `/account/${accountId}/project/${entityId}/remove-user`;
      } else {
        throw new Error(`Unsupported module type: ${moduleType}`);
      }
      
      // Call the DELETE API
      const response = await this.helper.request(
        "v1",
        apiEndpoint,
        {
          userId: item.uuid
        },
        "delete"
      );

      if (response.status === "success") {
        // Remove from local state only after successful API call
        this.removeUserFromArray(item);
        
        // Show success notification
        this.notif.current?.notify(
          "Success",
          `${item.name} has been removed from the ${moduleType}`,
          "success"
        );
      } else {
        // Show error notification
        this.notif.current?.notify(
          "Error",
          response.message || `Failed to remove user from ${moduleType}`,
          "error"
        );
      }
    } catch (error) {
      console.error(`Error removing user from ${this.getModuleType()}:`, error);
      this.notif.current?.notify(
        "Error",
        `Failed to remove user from ${this.getModuleType()}. Please try again.`,
        "error"
      );
    } finally {
      this.loader.destroy();
    }
  };

  render() {
    return (
      <div className="multiselectWindow">
        <Dialog onClose={this.props.manage.toggleDialog}>
          <Notification ref={this.notif} />
          <nav className="navbar bg-dark">
            <h6 style={{ color: "white", paddingTop: "3px" }}>
              {this.props.config.title} &nbsp; -&nbsp;&nbsp;
              {this.props.config.dataItem.name}
              &nbsp;&nbsp; <i className="fa fa-arrow-right"></i> &nbsp; Manage
              {" " + this.props.config.members}
            </h6>
          </nav>
          <div
            className="col-10 justify-content-center"
            style={{ margin: "auto" }}
          >
            <div style={{ margin: "auto", width: "85%", padding: "10px 0px" }}>
              <MSelect
                data={this.state.userList}
                onChange={this.handleChange}
                value={this.state.selectedUsers}
                filterable={true}
                onFilterChange={this.filterChange}
                onOpen={this.tagRender}
                onClose={this.tagRender}
                autoClose={true}
                clearButton={false}
                textField="name"
                dataItemKey="uuid"
                tagRender={this.tagRender}
                listNoDataRender={this.listNoDataRender}
                validationMessage={this.props.validationMessage}
                placeholder={"Click to add " + this.props.config.members}
              />
            </div>
          </div>
          {this.state.selectedUsers.length > 0 && (
            <div
              className="col-10 justify-content-center"
              style={{ margin: "auto", height: "70vh"}}
            >
              <Grid data={this.state.selectedUsers} scrollable={"scrollable"}>
                <GridColumn
                  field="name"
                  title={"Selected " + this.props.config.members}
                  headerCell={this.columnTitle}
                />
                {this.props.config.title!="Account"&&<GridColumn
                  title="Manage"
                  width="110px"
                  cells={{
                    data: cellWithEditing(
                      this.deleteRecord,
                      this.props.config.title
                    )
                  }}
                />}
              </Grid>
            </div>
          )}

          <DialogActionsBar>
            <button
              className="k-button btn-primary"
              onClick={() =>
                this.props.manage.postSelected(
                  this.state.selectedUsers,
                  this.props.config.dataItem.uuid
                )
              }
            >
              Save
            </button>
            <button
              className="k-button btn-secondary"
              onClick={this.props.manage.closeDialog}
            >
              Cancel
            </button>
          </DialogActionsBar>
        </Dialog>
      </div>
    );
  }
}

function cellWithEditing(remove, title) {
  return class extends React.Component {
    render() {
      return (
        <td>
          {this.props.dataItem.is_manager !== "1" ? (
            <center>
              <button
                className="k-primary k-button k-grid-edit-command"
                onClick={() => {
                  remove(this.props.dataItem);
                }}
              >
                Remove
              </button>
            </center>
          ) : title == "Account" ? (
            <center>
              <b>Admin</b>
            </center>
          ) : (
            <center>
              <b>Manager</b>
            </center>
          )}
        </td>
      );
    }
  };
}

export default MultiSelect;
